// Single source of truth for the "how strong / how weak" signal used across
// every surface that shows a score, percentage, or progress chip. The
// thresholds match the BCBA exam pass band convention: strong = 80%+,
// watch = 50-79%, weak = <50%. Components consume the returned tone token
// and apply the matching .status-strong / .status-watch / .status-weak
// utility classes defined in index.css.

export type StatusTone = "strong" | "watch" | "weak" | "neutral";

export function toneFromPct(pct: number | null | undefined): StatusTone {
  if (pct === null || pct === undefined || Number.isNaN(pct)) return "neutral";
  if (pct >= 80) return "strong";
  if (pct >= 50) return "watch";
  return "weak";
}

export function chipClass(tone: StatusTone): string {
  switch (tone) {
    case "strong": return "status-strong border";
    case "watch": return "status-watch border";
    case "weak": return "status-weak border";
    default: return "border border-border text-muted-foreground";
  }
}

export function fgClass(tone: StatusTone): string {
  switch (tone) {
    case "strong": return "status-strong-fg";
    case "watch": return "status-watch-fg";
    case "weak": return "status-weak-fg";
    default: return "text-muted-foreground";
  }
}
